import { Loader2 } from "lucide-react";

const LoadingState = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: "#F9FAFC" }}>
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin mx-auto mb-4" style={{ color: "#01793B" }} />
        <p className="font-medium" style={{ color: "#515164" }}>
          Loading payment information...
        </p>
      </div>
    </div>
  );
};

export default LoadingState;
